// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"N1-z"};